export default "/images/nextavenue.svg?b16f220335266196e91a6b1de066f7a6";